<template>
    <div class="main">
        <div class="back" @click="router.push('/personnelManage/personnel')"> <a-button type="primary"><i
                    class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button></div>
        <div class="mytable">
            <tableItem :tableStatus="0" :tableObjTitle="tableTitle" :tableObjData="tableObj">
                <template v-slot:headTitle>
                    姓名：{{ name }}
                </template>
            </tableItem>
        </div>

        <div class="tabs">
            <tabs :informationObj="tableObj" :firstData="firstData" :dataSource="dataSource"
                :dataSource2="dataSource2" />
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watch } from 'vue'
import tabs from './components/tabs.vue'
import tableItem from '@/components/tableItem/index.vue'
import { detailById, carDetailById, testTaskDetailById, testAccidentRecordDetailById } from '@/api/securityUser/index.js'
import { useRouter, useRoute } from 'vue-router';
import { result } from 'lodash-es';

const router = useRouter()
const route = useRoute()

const detailId = ref('')
const name = ref('')

const tableTitle = ref([
    { tableLeft: '创建人', tableRight: '更新人', dataSource: 'createByName', innerDataSource: 'updateByName' },
    { tableLeft: '创建时间', tableRight: '更新时间', dataSource: 'createTime', innerDataSource: 'updateTime' },
])

const tableObj = ref({
    plateNumber: '',
    createByName: '',
    updateByName: '',
    createTime: '',
    updateTime: ''
})

// 获取基本信息数据
const getData = () => {
    detailById(detailId.value).then(res => {
        console.log(res);
        if (res.code === 200) {
            name.value = res.data.name
            tableObj.value = res.data
        }
    })
}

const firstData = ref([])
// 关联车辆 数据
const getCarDetailById = () => {
    carDetailById(detailId.value).then(res => {
        console.log(res);
        if (res.code === 200) {
            res.data.forEach((item, index) => {
                item.index = index + 1
            })
            firstData.value = res.data
        }
    })
}

const dataSource = ref([])
// 测试记录数据
const getTestTaskDetailById = () => {
    testTaskDetailById(detailId.value).then(res => {
        console.log(res);
        if (res.code === 200) {
            dataSource.value = res.data
        }
    })
}

const dataSource2 = ref([])
// 事故记录数据
const getTestAccidentRecordDetailById = () => {
    testAccidentRecordDetailById(detailId.value).then(res => {
        console.log(res);
        if (res.code === 200) {
            dataSource2.value = res.data
        }
    })
}

onMounted(() => {
    detailId.value = route.query.modelId
    getData()
    getCarDetailById()
    getTestTaskDetailById()
    getTestAccidentRecordDetailById()
})

</script>

<style lang="less" scoped>
.main {
    padding: 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;

    .back {
        position: fixed;
        top: 93px;
        right: 50px
    }
}


::v-deep .mytable {
    width: 870px;
    font-size: 14px;
    font-weight: 400;
    color: #0a212e;
    text-align: left;
    margin: 16px auto 65px;

    tbody {
        border-inline-start: 1px solid #f0f0f0;
    }

    tr {
        border-inline-end: 1px solid #f0f0f0;
    }

    th {
        padding: 12px 28px;
        background-color: #eff0f5;
        border-bottom: 1px solid #f0f0f0;
    }

    td {
        padding: 12px 28px;
        border-bottom: 1px solid #f0f0f0;
        border-inline-end: 1px solid #f0f0f0;

    }
}



/deep/.ant-tabs .ant-tabs-tab+.ant-tabs-tab {
    margin: 0 0 0 114px;

}

/deep/.ant-tabs .ant-tabs-tab {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #1D2129;
}

/deep/.ant-tabs>.ant-tabs-nav .ant-tabs-nav-wrap {
    justify-content: center;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
}
</style>